export default "__VITE_ASSET__1ac6ef9c__"